import { render, staticRenderFns } from "./AgentDetailCard.vue?vue&type=template&id=550f4766&"
import script from "./AgentDetailCard.vue?vue&type=script&lang=js&"
export * from "./AgentDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./AgentDetailCard.vue?vue&type=style&index=0&id=550f4766&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports